import { createSlice } from "@reduxjs/toolkit";
import { setDocumentTypeListForGuardian } from "./guardianSlice";
import { setDocumentTypeListForDirector } from "./directorSlice";

export const documentSlice = createSlice({
  name: "documentDetails",
  initialState: {
    documentList: [],
    documentTypeList: [],
    districtList: [],
    rList: [],
    errors: {},
  },
  reducers: {
    setDocumentValue: (state, action) => {
      const document = state.documentList.find(
        (d) => d.documentTypeId === action.payload.code
      );

      if (document) {
        document[action.payload.key] = action.payload.value;
        document.op = "U";
      }
    },
    setSpecificDocument: (state, action) => {
      const index = state.documentList.findIndex(
        (d) => d.documentTypeId === action.payload.documentTypeId
      );

      if (index !== -1) {
        state.documentList[index] = { ...state.documentList[index], ...action.payload, op: "U" };
      } else {
        state.documentList.push({ ...action.payload, op: "U" });
      }

      if (state.errors && state.errors[action.payload.documentTypeId + "DocumentError"]) {
        state.errors[action.payload.documentTypeId + "DocumentError"] = null;
      };
    },
    setMainDocumentTypeList: (state, action) => {
      state.documentTypeList = action.payload;
      state.documentList = state.documentList.map((d) => {
        const documentType =
          action.payload.find((d1) => {
            return d.documentTypeId === d1.code;
          }) || {};

        return {
          ...d,
          documentType,
          documentTypeId: documentType.code,
          documentTypeDesc: documentType.descEng,
          documentTypeDescNp: documentType.descNep,
          type: documentType.type,
          isBothSided: documentType.isBothSided,
          ...documentType
        };
      });
    },
    setDistrictList: (state, action) => {
      state.districtList = action.payload;
    },
    pushDocumentListData: (state, action) => {
      const tempId =
        Math.max(...[...state.documentList.map((d) => d.tempId || 0), 0]) + 1;
      const documentData = { ...action.payload, tempId, op: "U" };
      state.documentList = [...state.documentList, documentData];
      state.errors = {};
    },
    removeDocumentListData: (state, action) => {
      state.documentList = state.documentList.filter((d) => {
        if (action.payload != (d.id || d.tempId)) {
          return true;
        } else {
          if (d.id) state.rList.push(d.id);
          return false;
        }
      });
    },
    updateDocumentListData: (state, action) => {
      const id = action.payload.id,
        documentDetail = action.payload.documentDetail;
      const index = state.documentList.findIndex(
        (d) => id == (d.id || d.tempId)
      );
      if (index !== -1)
        state.documentList[index] = {
          ...state.documentList[index],
          ...documentDetail,
          op: "U",
        };

      state.errors = {};
    },
    setDocumentListData: (state, action) => {
      state.documentList = action.payload.map((d) => {
        const documentType = state.documentTypeList.find(
          (d1) => d1.code === d.documentTypeId
        );

        return {
          ...d,
          ...(documentType
            ? {
              documentTypeId: documentType.code,
              documentTypeDesc: documentType.descEng,
              documentTypeDescNp: documentType.descNep,
              type: documentType.type,
              isBothSided: documentType.isBothSided,
              ...documentType
            }
            : {}),
        };
      });

      // action.payload
      //   .filter(
      //     (d) =>
      //       !state.documentList.find(
      //         (d1) => d1.documentTypeId === d.documentTypeId
      //       )
      //   )
      //   .forEach((d) => {
      //     state.documentList.push(d);
      //   });
    },
    resetDocumentListData: (state, action) => {
      state.rList = [];
      state.documentList = [
        ...state.documentList.filter((r) => r.op === "N"),
        ...action.payload.map((d) => {
          const documentType = state.documentTypeList.find(
            (d1) => d1.code === d.documentTypeId
          );

          return {
            ...d,
            ...(documentType
              ? {
                documentTypeId: documentType.code,
                documentTypeDesc: documentType.descEng,
                documentTypeDescNp: documentType.descNep,
                type: documentType.type,
                isBothSided: documentType.isBothSided,
                ...documentType,
                op: "N",
              }
              : {}),
          };
        }),
      ];
    },
    setDocumentError: (state, action) => {
      state.errors[action.payload.key] = action.payload;
    },
    clearDocumentData: (state, action) => {
      state.documentList.forEach((d) => (d.op = "N"));
    },
    setDocumentDetailsError: (state, action) => {
      state.errors.documentDetailsError = {};
      state.errors.documentDetailsError.message = action.payload.message;
      state.errors.documentDetailsError.section = action.payload.section;
    },
    setIssuedDateError: (state, action) => {
      if (!state.errors.issuedDateError) {
        state.errors.issuedDateError = {};
      }
      state.errors.issuedDateError.message = action.payload.message;
      state.errors.issuedDateError.section = action.payload.section;
    },
    setIssuedFromError: (state, action) => {
      if (!state.errors.issuedFromError) {
        state.errors.issuedFromError = {};
      }
      state.errors.issuedFromError.message = action.payload.message;
      state.errors.issuedFromError.section = action.payload.section;
    },
  },
});

export const {
  setDocumentError,
  setIssuedDateError,
  setIssuedFromError,
  setSpecificDocument,
  resetDocumentListData,
  updateDocumentListData,
  removeDocumentListData,
  pushDocumentListData,
  clearDocumentData,
  setDocumentValue,
  setMainDocumentTypeList,
  setDistrictList,
  setDocumentListData,
  setDocumentDetailsError,
} = documentSlice.actions;

export const setDocumentTypeList = (list) => (dispatch) => {
  dispatch(setMainDocumentTypeList(list));
  dispatch(setDocumentTypeListForGuardian(list));
  dispatch(setDocumentTypeListForDirector(list));
};

export default documentSlice.reducer;
